import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  VStack,
} from '@chakra-ui/react';

const faqs = [
  {
    question: "How does the booking system work?",
    answer: "Our booking system allows members to easily schedule tee times, lessons, or facility access through a user-friendly interface. Administrators can manage bookings, set availability, and handle cancellations all in one place."
  },
  {
    question: "What features are included in the membership management?",
    answer: "The membership management system includes member profiles, automated billing, attendance tracking, communication tools, and detailed analytics. You can easily manage different membership tiers and their associated privileges."
  },
  {
    question: "Is the platform customizable for different types of sports facilities?",
    answer: "Yes, our platform is highly customizable and can be tailored to various sports facilities including golf courses, tennis clubs, and fitness centers. You can adjust settings, features, and branding to match your specific needs."
  },
  {
    question: "How secure is the payment processing system?",
    answer: "We use industry-standard encryption and secure payment gateways to process all transactions. Our system complies with PCI DSS requirements and includes fraud prevention measures to protect both businesses and customers."
  },
  {
    question: "What kind of support do you offer?",
    answer: "We provide 24/7 technical support, comprehensive documentation, and regular training sessions. Our dedicated support team is always available to help with any questions or issues you may encounter."
  }
];

const FAQSection = () => {
  return (
    <Box py={20} bg="white">
      <Container maxW="container.xl">
        <VStack spacing={12}>
          <VStack spacing={4} textAlign="center" maxW="800px">
            <Heading as="h2" size="2xl" color="#110F14">
              Frequently Asked Questions
            </Heading>
            <Text fontSize="xl" color="gray.600">
              Find answers to common questions about our platform
            </Text>
          </VStack>

          <Accordion allowMultiple width="100%" maxW="800px">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                border="none"
                mb={4}
                bg="white"
                borderRadius="xl"
                boxShadow="sm"
                _hover={{ boxShadow: 'md' }}
              >
                <AccordionButton
                  p={6}
                  _hover={{ bg: 'gray.50' }}
                  _expanded={{ bg: '#110F14', color: 'white' }}
                  borderRadius="xl"
                >
                  <Box flex="1" textAlign="left" fontWeight="semibold">
                    {faq.question}
                  </Box>
                  <AccordionIcon color="#82ca9c" />
                </AccordionButton>
                <AccordionPanel
                  pb={6}
                  px={6}
                  color="gray.600"
                  fontSize="md"
                  lineHeight="tall"
                >
                  {faq.answer}
                </AccordionPanel>
              </AccordionItem>
            ))}
          </Accordion>
        </VStack>
      </Container>
    </Box>
  );
};

export default FAQSection; 